//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: String,
        large: Boolean,
        vertical: Boolean,
        flipIndicator: Boolean,
    },
};
